<template>
    <div>
        <!-- Modal Split -->
        <div class="modal fade" id="orcamentoSplitModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="orcamento">
                    <div class="modal-header">
                        <h5 class="modal-title">Separar Orçamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm table-hover small">
                            <thead>
                                <tr>
                                    <th>
                                        <a href="#" @click.prevent="marcar_todos()" class="card-link">
                                            <i class="fa fa-square" aria-hidden="true"></i>
                                        </a>
                                    </th>
                                    <th>Procedimento</th>
                                    <th>Código</th>
                                    <th class="text-right">Qtde</th>
                                    <th class="text-right">Vl. Unit.</th>
                                    <th class="text-right">Valor</th>
                                    <template v-if="tem_matmed">
                                        <th class="text-right">Mat/Med/Taxa</th>
                                        <th class="text-right">Total</th>
                                    </template>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(proced, ipx) in orcamento.js_procedimentos" :key="ipx">
                                    <td width="1%"><input type="checkbox" v-model="selecionados[ipx]" /></td>
                                    <td>{{ proced.procedimento.search }}</td>
                                    <td>{{ proced.item_tabela ? proced.item_tabela.st_codigo : '' }}</td>
                                    <td class="text-right">{{ proced.in_quantidade }}</td>
                                    <td class="text-right">{{ $util.formatMoeda( proced.dc_valor_procedimento ) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda( parseFloat(proced.dc_valor_procedimento) * proced.in_quantidade ) }}</td>
                                    <template v-if="tem_matmed">
                                        <td class="text-right">{{ $util.formatMoeda( total_consumos(proced) ) }}</td>
                                        <td class="text-right">{{ $util.formatMoeda( ( proced.dc_valor_procedimento * proced.in_quantidade ) + total_consumos(proced) ) }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            orcamento: null, 
            selecionados: [], 
            separados: {
                id_orcamento: null, 
                manter: [],
                novo: [], 
            }, 
        };
    },

    components: { 
        AzSubmit, 
    },

    computed: { 
        tem_matmed: function () { 
            if ( !this.orcamento || !this.orcamento.js_procedimentos ) { 
                return false; 
            }

            return this.orcamento.js_procedimentos.find(proced => proced && proced.atendimento_procedimento_consumos && proced.atendimento_procedimento_consumos.length)
                ? true
                : false; 
        }
    },

    methods: { 
        total_consumos (procedimento) { 
            if ( !procedimento || !procedimento.atendimento_procedimento_consumos ) { 
                return 0; 
            }

            return procedimento.atendimento_procedimento_consumos.reduce((total, carry) => { 
                return total + ( carry.dc_valor_unitario * carry.in_quantidade );
            }, 0);
        }, 

        marcar_todos () { 
            let selec = this.selecionados.find(item => item) ? false : true;

            console.log(this.selecionados, selec);

            this.selecionados.forEach((item, idx) => { 
                this.$set(this.selecionados, idx, selec);
            });
        },

        abrir (orcamento) { 

            if ( orcamento && orcamento.js_procedimentos && orcamento.js_procedimentos.length ) { 
                this.selecionados = orcamento.js_procedimentos.map(() => { 
                    return false; 
                });
            } else { 
                this.$toast.add({ 
                    severity: "warn",
                    summary: "Separar Orçamento",
                    detail: "Orçamento não identificado.",
                    life: 5000
                });
                return; 
            }

            this.separados.id_orcamento = orcamento.id_orcamento;
            this.separados.manter = []; 
            this.separados.novo = []; 

            this.orcamento = _.cloneDeep(orcamento); 

            $('#orcamentoSplitModal').modal('show');

        }, 

        atualizar () { 

            this.separados.manter = this.orcamento.js_procedimentos.filter((proced, idx) => !this.selecionados[idx]);
            this.separados.novo = this.orcamento.js_procedimentos.filter((proced, idx) => this.selecionados[idx]);

            if ( !this.separados.manter.length || !this.separados.novo.length ) { 
                this.$toast.add({ 
                    severity: "error",
                    summary: "Separar Orçamento",
                    detail: "Selecione os procedimentos que deseja separar.",
                    life: 5000
                });
                return; 
            }

            this.$util.atualizar(this, { 
                service: 'orcamentos', 
                func: 'separar',
                dados: this.separados, 
                toast: true, 
                modal: 'orcamentoSplitModal', 
                callback: () => { 
                    console.log('emit refresh', this.separados.id_orcamento);
                    this.$emit('refresh', this.separados.id_orcamento);
                }
            });

        }

    }

}
</script>
